export default __webpack_public_path__ + "static/media/03.bbd54f47.jpg";